<script setup lang="ts">
import { computed } from "vue";
import PlaylistAddIcon from "@/assets/icons/playlist-add.svg?component";

interface Props {
  modelValue: string[];
  value: string;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  "update:modelValue": [value: string[]];
  change: [];
}>();

const isSelected = computed(() => props.modelValue.includes(props.value));

const toggle = () => {
  const newValue = isSelected.value
    ? props.modelValue.filter((id) => id !== props.value)
    : [...props.modelValue, props.value];

  emit("update:modelValue", newValue);
};
</script>

<template>
  <div class="playlist-toggle-icon" :class="{ selected: isSelected }" @click.prevent="toggle">
    <PlaylistAddIcon width="16" />
  </div>
</template>

<style lang="scss" scoped>
.playlist-toggle-icon {
  cursor: pointer;
  flex-shrink: 0;
  transition: fill 0.2s;

  svg {
    width: 24px;
    height: 24px;
    fill: var(--gray-light);
    transition: fill 0.2s;
  }

  &:hover svg {
    fill: var(--palette-11);
  }

  &.selected svg {
    fill: var(--palette-11);
  }
}
</style>
